import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';

export const DashboardPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        TRGC Membership Application
      </h1>
      <div className="ps-2 pe-4">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 200px)'
          }}>
          <img src="logo-dark.png" alt="Company Logo" style={{ maxWidth: '100%' }} />
        </div>
      </div>
    </Layout>
  );
};
